var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { memo } from 'react';
import classnames from 'classnames';
import { Close } from '../../../foundations/icons';
import styles from './CloseButton.module.scss';
import { IconButton } from '../../../core/IconButton';
export var CloseButton = memo(function (_a) {
    var _b;
    var className = _a.className, close = _a.close, theme = _a.theme, props = __rest(_a, ["className", "close", "theme"]);
    return (React.createElement(IconButton, __assign({ "aria-label": "Close", className: classnames(className, styles.closeButton, (_b = {},
            _b[styles.light] = theme === 'light',
            _b)), id: "modalCloseButton" // iOS/Android apps rely on this id!
        , "data-webviewid": "modalCloseButton" // apps should start using this so we can remove the id reliance
        , onClick: close }, props),
        React.createElement(Close, { size: "small", className: styles.icon })));
});
//# sourceMappingURL=CloseButton.js.map